import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: '[libCreditCardNumber]',
  standalone: true
})
export class CreditCardNumberDirective {
  constructor(private el: ElementRef) {}

  @HostListener('input', ['$event'])
  onInputChange(event: any): void {
    let input = event.target.value;
    input = input.replace(/\D/g, ''); // Remove all non-numeric characters
    if (input.length <= 16) {
      // Add space after every 4 digits
      input = input.replace(/(\d{4})(?=\d)/g, '$1 ');
    }
    this.el.nativeElement.value = input;
  }
}
